import api from "../../Api";
import { BaseService } from "../../BaseService";


const URL = 'articles/highlights';

export class ArticlesHighlightsService extends BaseService {
    async list(): Promise<any[]> {
        try {
            return this.handleResponse(await api.get(`${URL}/list`));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async fetch(params: any): Promise<any> {
        try {
            return this.handleResponse(await api.post(`${URL}/create`, params));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }
}